// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"01defdda","617":"4c25efc3"}[chunkId] + ".chunk.css";
};